/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,@typescript-eslint/no-unused-vars */

xplenty.directive('windowContainer', [
  '$window',

  function ($window) {
    return {
      restrict: 'C',

      link(scope, element, attrs) {
        const resize = function () {
          element.css({
            width: $window.innerWidth,
            height: $window.innerHeight,
          });

          element.perfectScrollbar('update');
        };

        element.perfectScrollbar();

        angular.element($window).on('resize', resize);

        resize();
      },
    };
  },
]);
